<table class="relative min-w-full table-fixed divide-y divide-outline dark:divide-outline-darkmode">
  <thead>
    @if (!areAllPagesLoading()) {
      <tr>
        <th class="px-3 py-3.5 text-start text-sm font-normal">
          <ng-container
            *ngTemplateOutlet="
              columnHeader;
              context: {
                label: 'cockpit.supplierContracts.page.table.contractColumn' | transloco,
                subtitle: 'cockpit.supplierContracts.page.table.productSubtitle' | transloco,
                orderName: 'productName',
              }
            "
          />
        </th>
        <th class="px-3 py-3.5 text-start text-sm font-normal">
          <ng-container
            *ngTemplateOutlet="
              columnHeader;
              context: {
                label: 'cockpit.supplierContracts.page.table.locationsColumn' | transloco,
                subtitle: 'cockpit.supplierContracts.page.table.addressSubtitle' | transloco,
              }
            "
          />
        </th>
        <th class="px-3 py-3.5 text-start text-sm font-normal">
          <ng-container
            *ngTemplateOutlet="
              columnHeader;
              context: {
                label: 'cockpit.supplierContracts.page.table.connectionsColumn' | transloco,
                subtitle: 'cockpit.supplierContracts.page.table.maloIdSubtitle' | transloco,
              }
            "
          />
        </th>
        <th class="px-3 py-3.5 text-start text-sm font-normal">
          <ng-container
            *ngTemplateOutlet="
              columnHeader;
              context: {
                label: 'cockpit.supplierContracts.page.table.contractEndColumn' | transloco,
                subtitle:
                  'cockpit.supplierContracts.page.table.terminationPeriodSubtitle' | transloco,
                orderName: 'nextTerminationDate',
              }
            "
          />
        </th>
        <th class="px-3 py-3.5 text-start text-sm font-normal">
          <ng-container
            *ngTemplateOutlet="
              columnHeader;
              context: {
                label: 'cockpit.supplierContracts.page.table.annualConsumptionColumn' | transloco,
                subtitle: 'cockpit.supplierContracts.page.table.estimatedSubtitle' | transloco,
                textEnd: true,
              }
            "
          />
        </th>
        <th class="px-3 py-3.5 text-start text-sm font-normal">
          <ng-container
            *ngTemplateOutlet="
              columnHeader;
              context: {
                label: 'cockpit.supplierContracts.page.table.consumptionPriceColumn' | transloco,
                subtitle: 'cockpit.supplierContracts.page.table.perKwhSubtitle' | transloco,
                textEnd: true,
              }
            "
          />
        </th>
        <th class="px-3 py-3.5 text-start text-sm font-normal">
          <ng-container
            *ngTemplateOutlet="
              columnHeader;
              context: {
                label: 'cockpit.supplierContracts.page.table.energyCostsColumn' | transloco,
                subtitle:
                  'cockpit.supplierContracts.page.table.yearSubtitle'
                  | transloco: { year: currentYear() },
                textEnd: true,
              }
            "
          />
        </th>
        <th></th>
      </tr>
    } @else {
      <ng-container *ngTemplateOutlet="placeholder" />
    }
  </thead>
  <tbody
    class="divide-y divide-outline bg-surface dark:divide-outline-darkmode dark:bg-surface-darkmode"
  >
    @for (page of supplierContracts(); track page.page; let i = $index) {
      @if (page.isLoading) {
        @if (i === 0) {
          <ng-container *ngTemplateOutlet="placeholder" />
        } @else {
          @for (p of placeholders(); track $index) {
            <ng-container *ngTemplateOutlet="placeholder" />
          }
        }
      } @else if (page.error) {
        <tr>
          <td colspan="8" class="text-center">
            <app-error-page
              [error]="page.error"
              (clickBack)="router.navigate(['/organizations', organizationId()])"
              class="block"
              style="height: calc(100vh - 30rem)"
            />
          </td>
        </tr>
      } @else {
        @for (contract of page.contracts; track contract.id) {
          @let forecastKey = getForecastKey(contract.id, currentYear());
          @let price = prices()[forecastKey];
          @let cost = costs()[forecastKey];
          @if (isAvailableForForecast() && (!price || price.isLoading || !cost || cost.isLoading)) {
            <tr>
              <td colspan="8" class="px-3 py-3.5">
                <ui-skeleton class="w-full h-10 block rounded-md" />
              </td>
            </tr>
          } @else if (price?.error || cost?.error) {
            <tr>
              <td colspan="7">
                <div
                  class="px-3 py-3.5 flex items-center gap-2 text-surface-highlight dark:text-surface-highlight-darkmode"
                >
                  <div class="flex items-center h-10">
                    <ng-icon name="heroSignalSlash" size="24" class="!block" />
                  </div>
                  <p
                    class="leading-6 text-sm text-on-surface-disabled dark:text-on-surface-disabled-darkmode"
                  >
                    {{ 'shared.errorComponent.loadError' | transloco }}
                  </p>
                  <ui-button size="small" mode="ghost" (click)="onClickReload(contract.id)">
                    <ng-icon name="heroArrowPath" size="20" class="!block" slot="start" />
                    {{ 'shared.errorComponent.retryButton' | transloco }}
                  </ui-button>
                </div>
              </td>
              <td class="pr-3">
                <ui-button
                  mode="outlined"
                  [routerLink]="[
                    '/organizations',
                    organizationId(),
                    'supplier-contracts',
                    contract.id,
                  ]"
                  [attr.aria-label]="
                    'cockpit.supplierContracts.card.openContractButton' | transloco
                  "
                  [iconOnly]="true"
                  size="small"
                >
                  <ng-icon name="heroArrowRight" size="20" class="!block" />
                </ui-button>
              </td>
            </tr>
          } @else {
            <tr>
              <td class="px-3 py-3.5 text-sm">
                <div class="flex gap-2 items-center">
                  <div
                    class="flex-none p-2.5 rounded-lg shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)]"
                    [ngClass]="
                      {
                        ELECTRICITY:
                          'bg-power-soft dark:bg-power-soft-darkmode text-on-power-soft dark:text-on-power-soft-darkmode',
                        GAS: 'bg-gas-soft dark:bg-gas-soft-darkmode text-on-gas-soft dark:text-on-gas-soft-darkmode',
                      }[contract.utilityType]
                    "
                  >
                    @switch (contract.utilityType) {
                      @case ('ELECTRICITY') {
                        <ng-icon name="heroBolt" size="20" class="!block size-5" />
                      }
                      @case ('GAS') {
                        <ng-icon name="heroFire" size="20" class="!block size-5" />
                      }
                    }
                  </div>
                  <div class="whitespace-nowrap flex flex-col gap-0.5 flex-1">
                    <span class="font-semibold">
                      {{ contract.productName }}
                    </span>
                    @if (contract.supplierContractID || contract.supplierCustomerID) {
                      <span class="text-on-surface-subtle dark:text-on-surface-subtle-darkmode">
                        {{ contract.supplierContractID || contract.supplierCustomerID }}
                      </span>
                    }
                  </div>
                </div>
              </td>
              <td class="px-3 py-3.5 text-sm">
                <app-supplier-contract-locations [supplierContract]="contract" />
              </td>
              <td class="px-3 py-3.5 text-sm">
                <app-supplier-contract-energy-interfaces [supplierContract]="contract" />
              </td>
              <td class="px-3 py-3.5 text-sm">
                @if (contract.contractEndDate) {
                  <ui-badge>
                    <span class="flex gap-1 items-center">
                      <ng-icon name="heroFlag" size="16" class="!block" />
                      {{ contract.contractEndDate | date: 'dd.MM.yyyy' }}
                    </span>
                  </ui-badge>
                } @else {
                  <ui-badge>
                    <span class="flex gap-1 items-center">
                      <ng-icon name="heroArrowPathRoundedSquare" size="16" class="!block" />
                      {{ contract.terminationPeriodEndDate | date: 'dd.MM.yyyy' }}
                    </span>
                  </ui-badge>
                }
              </td>
              <td class="px-3 py-3.5 text-sm text-end">
                @if (isPastYear()) {
                  <ui-badge
                    [uiTooltip]="'cockpit.supplierContracts.card.noForecastPast' | transloco"
                    class="cursor-default"
                  >
                    -
                  </ui-badge>
                } @else if (!isAvailableForForecast()) {
                  <ui-badge
                    color="soft"
                    [uiTooltip]="'cockpit.supplierContracts.card.noForecastFuture' | transloco"
                    class="cursor-default"
                  >
                    {{ 'cockpit.supplierContracts.card.tooFarInFuture' | transloco }}
                  </ui-badge>
                } @else {
                  <ui-badge>
                    <span class="tabular-nums">
                      {{
                        price?.data?.totalConsumption ?? cost?.data?.totalConsumption ?? 0
                          | germanNumber: 0
                      }}
                      {{ 'cockpit.supplierContracts.units.referenceUnit.KWH' | transloco }}
                    </span>
                  </ui-badge>
                }
              </td>
              <td class="px-3 py-3.5 text-sm text-end">
                @if (isPastYear()) {
                  <ui-badge
                    [uiTooltip]="'cockpit.supplierContracts.card.noForecastPast' | transloco"
                    class="cursor-default"
                  >
                    -
                  </ui-badge>
                } @else if (!isAvailableForForecast()) {
                  <ui-badge
                    color="soft"
                    [uiTooltip]="'cockpit.supplierContracts.card.noForecastFuture' | transloco"
                    class="cursor-default"
                  >
                    {{ 'cockpit.supplierContracts.card.tooFarInFuture' | transloco }}
                  </ui-badge>
                } @else {
                  <ui-badge
                    mode="dot"
                    [color]="contract.consumptionPriceScoreOverride ?? '' | scoreColor"
                  >
                    <span class="tabular-nums">
                      {{
                        (fullPrice()
                          ? price?.data?.totalPrice
                          : price?.data?.totalPriceWithoutTaxes) ?? { min: 0, max: 0 }
                          | priceRange: 'CENTS' : 2
                      }}
                      {{ 'cockpit.supplierContracts.units.currencyUnit.CENTS' | transloco }}
                    </span>
                  </ui-badge>
                }
              </td>
              <td class="px-3 py-3.5 text-sm text-end">
                @if (isPastYear()) {
                  <ui-badge
                    [uiTooltip]="'cockpit.supplierContracts.card.noForecastPast' | transloco"
                    class="cursor-default"
                  >
                    -
                  </ui-badge>
                } @else if (!isAvailableForForecast()) {
                  <ui-badge
                    color="soft"
                    [uiTooltip]="'cockpit.supplierContracts.card.noForecastFuture' | transloco"
                    class="cursor-default"
                  >
                    {{ 'cockpit.supplierContracts.card.tooFarInFuture' | transloco }}
                  </ui-badge>
                } @else {
                  <ui-badge mode="dot" [color]="contract.costScoreOverride ?? '' | scoreColor">
                    <span class="tabular-nums">
                      {{
                        (fullPrice()
                          ? cost?.data?.totalEnergyCost
                          : cost?.data?.totalEnergyCostWithoutTaxes) ?? { min: 0, max: 0 }
                          | priceRange: 'EURO' : 2
                      }}
                      {{ 'cockpit.supplierContracts.units.currencyUnit.EURO_SYMBOL' | transloco }}
                    </span>
                  </ui-badge>
                }
              </td>
              <td class="pr-3">
                <ui-button
                  mode="outlined"
                  [routerLink]="[
                    '/organizations',
                    organizationId(),
                    'supplier-contracts',
                    contract.id,
                  ]"
                  [attr.aria-label]="
                    'cockpit.supplierContracts.card.openContractButton' | transloco
                  "
                  [iconOnly]="true"
                  size="small"
                >
                  <ng-icon name="heroArrowRight" size="20" class="!block" />
                </ui-button>
              </td>
            </tr>
          }
        }
      }
    }
  </tbody>
  @if (showLoadMorePlaceholders()) {
    <tbody
      appInViewport
      class="divide-y divide-outline bg-surface dark:divide-outline-darkmode dark:bg-surface-darkmode"
    >
      @for (p of placeholders(); track $index) {
        <ng-container *ngTemplateOutlet="placeholder" />
      }
    </tbody>
  }
</table>

<ng-template
  #columnHeader
  let-label="label"
  let-subtitle="subtitle"
  let-textEnd="textEnd"
  let-orderName="orderName"
>
  <button
    type="button"
    class="group flex items-center gap-2"
    [class.cursor-pointer]="orderName !== undefined"
    [class.text-start]="!textEnd"
    [class.justify-end]="textEnd"
    [class.justify-start]="!textEnd"
    [class.flex-row-reverse]="textEnd"
    (click)="onClickHeader(orderName)"
  >
    <div
      class="text-on-surface-subtle dark:text-on-surface-subtle-darkmode flex flex-col"
      [class.text-end]="textEnd"
    >
      <span class="whitespace-nowrap font-semibold text-on-surface dark:text-on-surface-darkmode">
        {{ label }}
      </span>
      <span class="whitespace-nowrap">{{ subtitle }}</span>
    </div>
    @if (orderName !== undefined) {
      <span
        [ngClass]="
          orderBy() === orderName
            ? 'p-0.5 flex-none rounded-sm text-on-surface dark:text-on-surface-darkmode bg-surface-variant dark:bg-surface-variant-darkmode group-hover:bg-surface-highlight dark:group-hover:bg-surface-highlight-darkmode'
            : 'invisible p-0.5 flex-none rounded-sm text-on-surface-disabled dark:text-on-surface-disabled-darkmode group-hover:visible group-focus:visible'
        "
      >
        <ng-icon
          [name]="
            orderBy() !== orderName || orderDirection() === 'desc'
              ? 'heroChevronDown'
              : 'heroChevronUp'
          "
          size="16"
          class="!block"
        />
      </span>
    }
  </button>
</ng-template>

<ng-template #placeholder>
  <tr>
    <td colspan="8" class="px-3 py-3.5">
      <ui-skeleton class="w-full h-[42px] block rounded-md" />
    </td>
  </tr>
</ng-template>
